import { useQuery } from '@tanstack/react-query';
import { ScheduleApiService } from '../../services/scheduleApiService';
import { Show } from '../../types/Show';
import { cachingStrategyService, DataType } from '../../services/cachingStrategyService';

export const SCHEDULE_QUERY_KEY = ['schedule'] as const;

export const useScheduleQuery = () => {
  // Get optimized caching strategy for schedule data
  const cacheStrategy = cachingStrategyService.getStrategy(DataType.SCHEDULE_DATA);
  
  return useQuery({
    queryKey: SCHEDULE_QUERY_KEY,
    queryFn: async (): Promise<Show[]> => {
      const response = await ScheduleApiService.getSchedule();
      if (!response.success) {
        throw new Error(response.error || 'Failed to fetch schedule');
      }
      return response.data;
    },
    // Apply centralized caching strategy
    staleTime: cacheStrategy.staleTime,
    gcTime: cacheStrategy.gcTime,
    refetchInterval: cacheStrategy.refetchInterval,
    refetchIntervalInBackground: cacheStrategy.refetchIntervalInBackground,
    refetchOnWindowFocus: cacheStrategy.refetchOnWindowFocus,
    refetchOnReconnect: cacheStrategy.refetchOnReconnect,
    retry: cacheStrategy.retry,
    retryDelay: cacheStrategy.retryDelay,
  });
};
